module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', {
    staticClass: "key-title"
  }, [_vm._v("已录入的维度")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('p', {
    staticClass: "keys"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('el-tag', {
      key: item.ID,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleDelete(item.ID)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.TITLE) + "\n          ")])
  }), 1)])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "40px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "size": "small",
      "placeholder": "录入新的功能类别"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "inputValue"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-7bd4c02f!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/widgetTag.vue
// module id = 470
// module chunks = 11